var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 981 980",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.316 979.534c-130.9 0-253.9-51-346.5-143.5s-143.5-215.6-143.5-346.5c0-92.7 26-182.9 75.2-261 47.9-75.8 115.5-137.1 195.6-177.2l41.2 82.1c-65.1 32.6-120.1 82.5-159 144.2-39.9 63.4-61.1 136.7-61.1 212 0 219.5 178.6 398.1 398.1 398.1 219.5 0 398.1-178.6 398.1-398.1 0-75.3-21.1-148.6-61.1-212-38.9-61.7-93.9-111.6-159-144.2l41.2-82.1c80.1 40.1 147.7 101.4 195.6 177.3 49.2 78 75.2 168.3 75.2 261 0 130.9-51 253.9-143.5 346.5-92.6 92.5-215.6 143.4-346.5 143.4z",
    fillRule: "nonzero"
  })));
}
export default SvgLoader;